import React, { useEffect, useState } from 'react';
import { InputProp } from '../../utils/tsConfig';

const Number: React.FC<InputProp> = (props) => {
	const { keyId, distinctKey, type, setState, state, isArray, needCheck, aditionalInfo, customeTypable = false, indexVal, arrayName, min = 0, max = 100000, length, valueShowKey, className, returnKey, fieldName, options, optionsAll, optionDisplay, optionKey, didntShowKey, width = '10vw', onChange, required = false, disabled = false, dropdownWidthStyle } = props;

	const [selected, setSelected] = useState('');
	const onChangeValue = (e: any) => {
		if (e.target.value.length > max || e.target.value.length < min) {
			return;
		}
		if (length && e.target.value.length <= length) return;

		if (isArray) {
			if (arrayName && indexVal !== undefined && returnKey && setState) {
				if (state[arrayName] && state[arrayName][indexVal] && state[arrayName][indexVal][returnKey]) {
					const updatedState = { ...state };
					updatedState[arrayName][indexVal][returnKey] = e.target.value;
					setState(updatedState);
					setSelected(e.target.value);
				} else {
					const updatedState = { ...state };
					if (!updatedState[arrayName]) {
						updatedState[arrayName] = [];
					}
					while (updatedState[arrayName].length <= indexVal) {
						updatedState[arrayName].push({});
					}
					if (typeof updatedState[arrayName][indexVal] !== 'object' || updatedState[arrayName][indexVal] === null) {
						updatedState[arrayName][indexVal] = {};
					}
					updatedState[arrayName][indexVal][returnKey] = e.target.value;
					setState(updatedState);
					setSelected(e.target.value);
				}
			}
		} else {
			if (onChange) {
				onChange({ value: e.target.value });
			}
			if (setState) {
				if (returnKey) {
					setState({ ...state, [returnKey]: e.target.value });
				} else {
					setState(e.target.value);
				}
			}
		}
	};

	useEffect(() => {
		if (isArray) {
			if (arrayName && indexVal !== undefined && returnKey) {
				if (state[arrayName] && state[arrayName][indexVal] && state[arrayName][indexVal][returnKey]) {
					setSelected(state[arrayName][indexVal][returnKey]);
				}
			}
		} else {
			if (returnKey) {
				setSelected(state?.[returnKey]);
			} else {
				setSelected(state);
			}
		}
	}, [returnKey, state, isArray, arrayName, indexVal]);

	return (
		<label key={keyId} className={`customInput ${className}`}>
			<input value={selected || ''} required={required} maxLength={max} minLength={min} disabled={disabled} className='input__field outline-none border border-gray-200 rounded-md lg:text-sm xl:text-md lg:text-left md:text-center dark:bg-[#202020f5] dark:text-slate-200' onChange={onChangeValue} type='number' placeholder=' ' />
			<span className='input__label dark:bg-[#202020f5] dark:text-slate-200 dark:rounded-md px-1'>
				{fieldName.replace(/\*$/, '')}
				{fieldName.endsWith('*') && <span className='mandatory-asterisk'>*</span>}
			</span>
			{length && selected?.length && <span className='text-xs text-gray-500 dark:text-gray-300 mt-1 block'>{`${length - selected.length} characters left`}</span>}
		</label>
	);
};

export default Number;
